import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const getPerDiemFileTypes = () => makeRequest(authFetch.get('api/PerDiemCustomContracts/FileTypes'));

export const getPerDiemFiles = (id, params) => makeRequest(
  authFetch.get(`api/PerDiemCustomContracts/${id}/Files${getQueryParams(params)}`),
);

export const postPerDiemFiles = (id, files) => makeRequest(authFetch.post(`api/PerDiemCustomContracts/${id}/Files`, files));

export const deletePerDiemFile = (id, fileId) => makeRequest(authFetch.delete(`api/PerDiemCustomContracts/${id}/Files/${fileId}`));

export const getPerDiemNotes = (id) => makeRequest(authFetch.get(`api/PerDiemCustomContracts/${id}/Notes`));

export const postPerDiemNotes = (id, notes) => makeRequest(authFetch.post(`api/PerDiemCustomContracts/${id}/Notes`, notes));

export const getPerDiemCustomContractAudits = (id, params) => makeRequest(authFetch.get(`/api/PerDiemCustomContracts/${id}/Audits${getQueryParams(params)}`));
export const getPerDiemCustomContractAuditProperties = (id) => makeRequest(authFetch.get(`/api/PerDiemCustomContracts/${id}/Audits/Properties`));
export const getPerDiemCustomContractAuditUsers = (id) => makeRequest(authFetch.get(`/api/PerDiemCustomContracts/${id}/Audits/Users`));

export const getPerDiemCalendarTypes = () => makeRequest(authFetch.get('/api/PerDiem/CalendarTypes'));

export const getPerDiemStreetTurnMethods = () => makeRequest(authFetch.get('/api/PerDiem/StreetTurnMethods'));

export const getPerDiemCustomContractsPaginated = (params) => makeRequest(authFetch.get(`/api/PerDiemCustomContracts${getQueryParams(params)}`));

export const getPerDiemCustomContractById = (id) => makeRequest(authFetch.get(`/api/PerDiemCustomContracts/${id}`));

export const restorePerDiemCustomContractById = (id) => makeRequest(authFetch.patch(`/api/PerDiemCustomContracts/${id}/restore`));

export const deletePerDiemCustomContractById = (id) => makeRequest(authFetch.delete(`/api/PerDiemCustomContracts/${id}`));

export const updateCustomContract = (data) => makeRequest(authFetch.put('/api/PerDiemCustomContracts', data));
